import type { ResponsiveValue } from 'styled-system';

import type { GridProps } from '../extensions';
import { grid } from '../extensions';
import styledFactory from '../styledFactory';
import variantFactory from '../variantFactory';

export interface Props extends GridProps {
  variant?: ResponsiveValue<string>;
  __containerCommon__?: 'common';
}

/**
 * Use the Container component to center content horizontally
 * with a max-width and left/right gutters
 */
const Container = styledFactory<Props, 'div'>(
  'div',
  'Container',
  [
    variantFactory('components.container', { prop: '__containerCommon__' }),
    variantFactory('components.container.variants'),
  ],
  [grid],
  `box-sizing: content-box;`,
  {
    variant: 'default',
    __containerCommon__: 'common',
  },
);

export default Container;
